import api from 'api'

export interface WorkExperienceCredential {
  name: string
  requirementId: number
  credentialId?: number
  categories: string[]
  requirementType: string
  verificationType: string
  status: string
  expirationDate?: string
  documentNeeded?: boolean // True if a document needs to be uploaded for verification
  credential?: string // Legacy credential type (e.g., 'fork_lift', 'food_handlers_card', 'none')
}

export interface WorkExperienceFormOptions {
  categories: string[]
  skills: WorkExperienceCredential[]
}

export async function getWorkExperienceFormOptions(): Promise<WorkExperienceFormOptions> {
  const response = await api.get<WorkExperienceFormOptions>(
    '/work_experience/form/options'
  )
  return response.data
}
